import { omitTypename } from '../../hooks/shared';

// Formatting from camel case to kebab-case to support format expected by Platform.
// Note: This is not scalable and should be revisited
function formatKey(key) {
  switch (key) {
    case 'livingRoom':
      return 'living-room';
    case 'primaryBedroom':
      return 'primary-bedroom';
    case 'guestBedroom':
      return 'guest-bedroom';
    case 'bonusRoom':
      return 'bonus-room';
    case 'kidsBedroom':
      return 'kids-bedroom';
    case 'storageCloset':
      return 'storage-closet';
    case 'diningRoom':
      return 'dining-room';
    case 'largeSafe':
      return 'large-safe';
    case 'dishWasher':
      return 'dish-washer';
    case 'washerOrDryer':
      return 'washer-dryer';
    case 'largeFreezer':
      return 'large-freezer';
    case 'ovenOrStove':
      return 'oven-stove';
    case 'ridingLawnMower':
      return 'riding-lawn-mower';
    case 'largeArmoire':
      return 'large-armoire';
    default:
      return key;
  }
}

export function mapMetadata(metadata) {
  return metadata
    ? [
        ...Object.keys(metadata)
          ?.filter(key => key !== 'reservedParking') // stripping parking metadata from being sent to API for now
          .map(key => {
            if (key === 'elevator') {
              const value = metadata[key]?.toString().startsWith('TRUE'); // only send TRUE/FALSE for elevator, so trim those two options to same value for API
              return {
                key,
                value: value ? 'true' : 'false',
              };
            }
            if (key === 'stories') {
              // Conversion from stories to stairs as requested by Platform
              return {
                key: 'stairs',
                value: metadata.stories && Number(metadata.stories) > 1 ? (metadata.stories - 1).toString() : '0',
              };
            }
            return {
              key: formatKey(key),
              value: metadata[key]?.toString(),
            };
          }),
        // Add elevator reserved param as requested by Platform
        {
          key: 'elevatorReserved',
          value: metadata.elevator?.toString().startsWith('TRUE') ? 'true' : 'false',
        },
      ]
    : null;
}

/*
  Takes property metadata - current inventory and intent
  Returns those as keys on the first location only
*/
export default function mapPropertyInfo(locations, metadata) {
  return locations.map(({ id, propertyInfo }, i) => ({
    id,
    propertyInfo: {
      ...omitTypename(propertyInfo),
      metadata:
        i === 0 && metadata ? mapMetadata({ ...propertyInfo?.metadata, ...metadata }) : mapMetadata(propertyInfo?.metadata),
    },
  }));
}
